import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateBlockDirective } from '@ngx-translate/core';
import { SelectButtonChangeEvent, SelectButtonModule } from 'primeng/selectbutton';
import { Skeleton } from 'primeng/skeleton';
import { InputSelectButtonInterface } from '../../../types/interfaces/input.interface';

@Component({
  selector: 'app-input-select-button',
  imports: [
    SelectButtonModule,
    ReactiveFormsModule,
    Skeleton,
    TranslateBlockDirective,
  ],
  templateUrl: './input-select-button.html',
  styleUrl: './input-select-button.css',
})
export class InputSelectButton {
  @Input()
  public formData!: InputSelectButtonInterface;

  @Input()
  public isLoading: boolean = false;

  public onSelectChange(event: SelectButtonChangeEvent) {
    if (this.formData.onInput && event.originalEvent) {
      this.formData.onInput(event.originalEvent);
    }
  }
}
